const SET_LANGUAGE = 'SET_LANGUAGE';

export const languageReducer = (state = "ru", action) => {
    switch (action.type) {
        case SET_LANGUAGE:
            return action.payload;
        default:
            return state;
    }
};
